// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1gyOD","left":"StickyBox_left__mOUL9","right":"StickyBox_right__3Ac2X"};